var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "236px",
    height: "216px",
    viewBox: "0 0 236 216",
    enableBackground: "new 0 0 236 216",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#47CBE6",
    d: "M230.133,64.498c0,1.333,0,2.667,0,4 c-30.344,29.007-65.547,61.328-100,90c-14.544,12.104-28.298,29.287-46,35c-12.788,4.127-26.985,4.721-40,8 c-12.262,3.088-24.001,11.127-38,8c0.163-1.162-0.221-1.779-1-2c0-1.334,0-2.668,0-4c4.567-6.215,9.946-21.316,15-35 c4.471-12.105,8.496-26.332,14-35c3.761-5.923,13.875-13.007,22-20c7.578-6.522,15.794-13.242,23-20 c15.103-14.163,28.747-32.322,41-44c6.979-6.652,16.274-12.214,26-21c6.839-6.178,17.874-21.703,24-23 c11.525-2.44,28.876,7.719,35,14C216.832,31.497,221.982,49.709,230.133,64.498z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M183.133,30.498c0.24-1.427,1.646-1.687,2-3 c-1.574-0.52-5.355-3.85-7-1C180.129,27.502,179.711,30.919,183.133,30.498z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M162.133,30.498c5,0.63,10.252,10.23,14,3 C172.071,31.876,164.767,21.464,162.133,30.498z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M148.133,42.498c5.205,1.129,7.303,5.364,12,7 c-0.541-3.541,3.541-2.459,3-6c-3.875-2.125-5.95-6.05-11-7C151.511,39.208,147.956,38.986,148.133,42.498z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M176.133,55.498c-6.173,4.411-12.657,8.486-18,12 c-13.097,8.613-21.335,19.199-31,28c-16.408,14.941-31.454,28.565-47,42c-4.977,4.301-14.325,9.152-10,18 c8.37,3.559,13.678-5.514,18-10c24.84-25.788,56.904-45.873,84-68c11.109-9.072,23.921-16.455,31-28 C196.955,36.276,185.402,48.874,176.133,55.498z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M132.133,58.498c4.156-5.064,10.146,0.642,15,1 c0.013-1.987,2.729-1.271,2-4C145.064,47.888,130.139,50.764,132.133,58.498z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M213.133,60.498c-38.926,35.406-85.717,62.949-123,100 c2.912,3.088,1.956,10.043,6,12c35.803-30.618,72.007-65.76,107-96c4.861-4.2,12.893-7.4,13-15 C214.855,61.443,214.748,60.216,213.133,60.498z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M126.133,78.498c1.046-3.955,6.689-3.311,7-8 c-6.583,1.249-8.781-1.886-13-3C120.111,73.187,124.112,74.852,126.133,78.498z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M113.133,87.498c3.869,0.869,3.558-2.442,6-3 c-0.746-3.921-3.954-5.379-7-7C107.842,80.8,112.565,83.484,113.133,87.498z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M86.133,108.498c-6.969,3.725-16.02,1.916-17,13 c6.62,3.456,11.886-4.727,17-9c5.54-4.629,13.337-8.811,16-15C92.938,93.406,83.9,99.055,86.133,108.498z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M40.133,140.498c-1.039,10.985-10.439,22.574-8,33 c1.833,7.836,12.862,8.393,14,17c12.82-3.848,26.749-6.585,40-10c-1.142-5.858-2.833-11.168-6-15c-6.465-0.203-12.448-0.887-18-2 c-1.125-4.542-1.582-9.752-3-14C52.231,147.066,48.112,141.852,40.133,140.498z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBlue);
export default __webpack_public_path__ + "static/media/pencilBlue.b2ab4f37f31e2f07b6c96d04538f2bfa.svg";
export { ForwardRef as ReactComponent };